<template>
  <div class="block">
    <div class="caption">
      <div class="caption-title">
        <span v-if="isTeamLeader">
          {{ $tr('responses.tabs.team.teamLeader') }}
        </span>
        <span v-else>
          {{ $tr('responses.tabs.team.participant') }} {{ index }}
        </span>
      </div>
      <div class="caption-block-hide" @click="toggleBlock">
        <i v-if="this.isBlockHidden" class="fa fa-caret-down"></i>
        <i v-else class="fa fa-caret-up"></i>
      </div>
    </div>
    <div class="block-content" v-if="!this.isBlockHidden">
      <div class="item">
        <div>
          {{ $tr('responses.tabs.team.participantData.name') }}
        </div>
        <div>
          {{ item.first_name }}
        </div>
      </div>
      <div class="item">
        <div>
          {{ $tr('responses.tabs.team.participantData.surname') }}
        </div>
        <div>
          {{ item.last_name }}
        </div>
      </div>
      <div class="item">
        <div>
          {{ $tr('responses.tabs.team.participantData.city') }}
        </div>
        <div>
          {{ item.city }}
        </div>
      </div>
      <div class="item">
        <div>
          {{ $tr('responses.tabs.team.participantData.university') }}
        </div>
        <div>
          {{ item.university }}
        </div>
      </div>
      <div class="item">
        <div>
          {{ $tr('responses.tabs.team.participantData.yearOfGraduation') }}
        </div>
        <div>
          {{ item.graduation_year }}
        </div>
      </div>
      <div class="item">
        <div>
          {{ $tr('responses.tabs.team.participantData.graduationDegree') }}
        </div>
        <div>
          {{ item.graduation_degree }}
        </div>
      </div>
      <div class="item">
        <div>
          {{ $tr('responses.tabs.team.participantData.directionOfStudy') }}
        </div>
        <div>
          {{ item.direction_of_study}}
        </div>
      </div>
      <div class="item">
        <div>
          {{ $tr('responses.tabs.team.participantData.englishLevel') }}
        </div>
        <div>
          {{ item.english_level }}
        </div>
      </div>
      <div class="item">
        <div>
          {{ $tr('responses.tabs.team.participantData.phoneNumber') }}
        </div>
        <div>
          {{ item.phone }}
        </div>
      </div>
      <div class="item">
        <div>
          {{ $tr('responses.tabs.team.participantData.email') }}
        </div>
        <div>
          {{ item.email }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'response-tabs-team-member-item',

  props: {
    item: Object,
    index: Number,
    isTeamLeader: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    blockHiddenId () {
      return 'response-team-block-member-' + this.index
    },

    isBlockHidden () {
      return Boolean(this.$store.getters['response/blockHidden'][this.blockHiddenId])
    }
  },

  methods: {
    toggleBlock () {
      this.$store.dispatch('response/toggleBlock', this.blockHiddenId)
    }
  }
}
</script>


<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/variables.scss';

.block {
  border-bottom: 1px solid #d7d7d7;
  margin-right: 40px;

  .caption {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;

    .caption-title {
      font-size: 16px;
      font-weight: bold;
    }

    .caption-block-hide {
      color: $green;
      cursor: pointer;
    }
  }

  .block-content {
    .item {
      padding: 10px 0px;
      display: flex;
      width: 100%;
      div:first-child {
        width: 25%;
        min-width: 25%;
      }
    }
  }

  &.block-additional {
    .block-content {
      .item {
        :first-child {
          width: 80%;
          padding-right: 5px;
        }
        :not(:first-child) {
          color: $green;
        }
        .gray {
          color: $grey-color;
        }
      }
    }
  }
}
</style>
